import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';

interface IBarcodePart {
  label: string,
  code: string,
}

const BARCODE_PARTS: (IBarcodePart & {
  groupLabel2: string,
  groupLabel3: string,
  groupLabel4: string,
  groupLabel5: string,
  group2: IBarcodePart[],
  group3: IBarcodePart[],
  group4: IBarcodePart[],
  group5: IBarcodePart[]
})[] = [
    {
      label: 'Poster',
      code: '001',
      groupLabel2: 'Bredd',
      groupLabel3: 'Höjd',
      groupLabel4: 'Papper',
      groupLabel5: 'Ram',
      group2: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group3: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group4: [
        { label: 'Obestruket', code: '001' },
        { label: 'Bestruket', code: '002' },
      ],
      group5: [
        { label: 'Ingen', code: '000' },
        { label: 'Svart', code: '001' },
        { label: 'Vit', code: '002' },
        { label: 'Ek', code: '003' },
        { label: 'Metall - svart', code: '004' },
        { label: 'Metall - guld', code: '005' },
        { label: 'Metall - silver', code: '006' },
        { label: 'Tavellist', code: '007' },
      ]
    },
    {
      label: 'Stock Item',
      code: '002',
      groupLabel2: '',
      groupLabel3: '',
      groupLabel4: '',
      groupLabel5: '',
      group2: [],
      group3: [],
      group4: [],
      group5: []
    },
    {
      label: 'Canvas',
      code: '003',
      groupLabel2: 'Bredd',
      groupLabel3: 'Höjd',
      groupLabel4: '',
      groupLabel5: '',
      group2: [
        { label: '20cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '60cm', code: '060' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group3: [
        { label: '20cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '60cm', code: '060' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group4: [],
      group5: []
    },
    {
      label: 'Poster(auto URL)',
      code: '004',
      groupLabel2: 'Bredd',
      groupLabel3: 'Höjd',
      groupLabel4: 'Papper',
      groupLabel5: 'Ram',
      group2: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group3: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group4: [
        { label: 'Obestruket', code: '001' },
        { label: 'Bestruket', code: '002' },
      ],
      group5: [
        { label: 'Ingen', code: '000' },
        { label: 'Svart', code: '001' },
        { label: 'Vit', code: '002' },
        { label: 'Ek', code: '003' },
        { label: 'Metall - svart', code: '004' },
        { label: 'Metall - guld', code: '005' },
        { label: 'Metall - silver', code: '006' },
        { label: 'Tavellist', code: '007' },
      ]
    },
    {
      label: 'Poster(Google Storage)',
      code: '005',
      groupLabel2: 'Bredd',
      groupLabel3: 'Höjd',
      groupLabel4: 'Papper',
      groupLabel5: 'Ram',
      group2: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group3: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group4: [
        { label: 'Obestruket', code: '001' },
        { label: 'Bestruket', code: '002' },
      ],
      group5: [
        { label: 'Ingen', code: '000' },
        { label: 'Svart', code: '001' },
        { label: 'Vit', code: '002' },
        { label: 'Ek', code: '003' },
        { label: 'Metall - svart', code: '004' },
        { label: 'Metall - guld', code: '005' },
        { label: 'Metall - silver', code: '006' },
        { label: 'Tavellist', code: '007' },
      ]
    },
    {
      label: 'Student',
      code: '006',
      groupLabel2: 'Bredd',
      groupLabel3: 'Höjd',
      groupLabel4: '',
      groupLabel5: '',
      group2: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group3: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group4: [],
      group5: []
    },
    {
      label: 'Poster(Gateway - ID)',
      code: '007',
      groupLabel2: 'Bredd',
      groupLabel3: 'Höjd',
      groupLabel4: 'Papper',
      groupLabel5: 'Ram',
      group2: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group3: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group4: [
        { label: 'Obestruket', code: '001' },
        { label: 'Bestruket', code: '002' },
      ],
      group5: [
        { label: 'Ingen', code: '000' },
        { label: 'Svart', code: '001' },
        { label: 'Vit', code: '002' },
        { label: 'Ek', code: '003' },
        { label: 'Metall - svart', code: '004' },
        { label: 'Metall - guld', code: '005' },
        { label: 'Metall - silver', code: '006' },
        { label: 'Tavellist', code: '007' },
      ]
    },
    {
      label: 'Poster(Pictufy)',
      code: '008',
      groupLabel2: 'Bredd',
      groupLabel3: 'Höjd',
      groupLabel4: 'Papper',
      groupLabel5: 'Ram',
      group2: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group3: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group4: [
        { label: 'Poster', code: '001' },
        { label: 'Canvas', code: '002' },
      ],
      group5: [
        { label: 'Ingen', code: '000' },
        { label: 'Svart', code: '001' },
        { label: 'Vit', code: '002' },
        { label: 'Ek', code: '003' },
        { label: 'Metall - svart', code: '004' },
        { label: 'Metall - guld', code: '005' },
        { label: 'Metall - silver', code: '006' },
        { label: 'Tavellist', code: '007' },
      ]
    },
    {
      label: 'Wallpaper',
      code: '009',
      groupLabel2: '',
      groupLabel3: '',
      groupLabel4: '',
      groupLabel5: '',
      group2: [],
      group3: [],
      group4: [],
      group5: []
    },
    {
      label: 'Manuell uppladdning',
      code: '010',
      groupLabel2: 'Bredd',
      groupLabel3: 'Höjd',
      groupLabel4: 'Typ',
      groupLabel5: 'Papper',
      group2: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group3: [
        { label: '21cm', code: '021' },
        { label: '30cm', code: '030' },
        { label: '40cm', code: '040' },
        { label: '50cm', code: '050' },
        { label: '70cm', code: '070' },
        { label: '100cm', code: '100' }
      ],
      group4: [
        { label: 'Poster', code: '001' },
        { label: 'Canvas', code: '002' },
      ],
      group5: [
        { label: 'Obestruket', code: '001' },
        { label: 'Bestruket', code: '002' },
      ]
    }
  ]

@Component({
    selector: 'barcode-generator',
    templateUrl: './barcode-generator.component.html',
    styleUrls: ['./barcode-generator.component.scss'],
    standalone: false
})
export class BarcodeGeneratorComponent {
  barcodeParts = BARCODE_PARTS;

  @Input()
  preSelectedType?: string;

  @Input()
  simpleSizeSelector?: boolean;

  @Output()
  barcodeChanged: EventEmitter<string> = new EventEmitter<string>();

  selectedSimpleSize?: string;

  selectedIndex1: number = -1;
  selectedIndex2: number = -1;
  selectedIndex3: number = -1;
  selectedIndex4: number = -1;
  selectedIndex5: number = -1;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, private globals: Globals) {

  }

  async ngOnInit() {
    if (this.preSelectedType) {
      this.selectTypeIndex(this.barcodeParts.indexOf(this.barcodeParts.find(p => p.code === this.preSelectedType)));
    }
    this.barcodeUpdated();
  }

  selectTypeIndex(index: number) {
    this.selectedIndex1 = index;

    this.selectedIndex2 = -1;
    this.selectedIndex3 = -1;
    this.selectedIndex4 = -1;
    this.selectedIndex5 = -1;

    this.barcodeUpdated();
  }


  selectSimpleSize(widthCode: string, heightCode: string) {
    this.selectedIndex2 = this.barcodeParts[this.selectedIndex1].group2.findIndex(g => g.code === widthCode);
    this.selectedIndex3 = this.barcodeParts[this.selectedIndex1].group3.findIndex(g => g.code === heightCode);
    this.selectedSimpleSize = `${widthCode}${heightCode}`;
    this.barcodeUpdated();
  }

  selectIndex2(index: number) {
    this.selectedIndex2 = index;
    this.barcodeUpdated();
  }

  selectIndex3(index: number) {
    this.selectedIndex3 = index;
    this.barcodeUpdated();
  }

  selectIndex4(index: number) {
    this.selectedIndex4 = index;
    this.barcodeUpdated();
  }

  selectIndex5(index: number) {
    this.selectedIndex5 = index;
    this.barcodeUpdated();
  }

  barcodeUpdated() {
    this.barcodeChanged.emit(this.getBarcode());
  }

  getBarcode() {
    if (this.selectedIndex1 >= 0) {
      let barcodeParts = BARCODE_PARTS[this.selectedIndex1];
      let barcode = barcodeParts.code;

      if (barcodeParts.group2[this.selectedIndex2 as number])
        barcode += `-${barcodeParts.group2[this.selectedIndex2 as number].code}`;
      else
        barcode += '-000';

      if (barcodeParts.group3[this.selectedIndex3 as number])
        barcode += `-${barcodeParts.group3[this.selectedIndex3 as number].code}`;
      else
        barcode += '-000';

      if (barcodeParts.group4[this.selectedIndex4 as number])
        barcode += `-${barcodeParts.group4[this.selectedIndex4 as number].code}`;
      else
        barcode += '-000';

      if (barcodeParts.group5[this.selectedIndex5 as number])
        barcode += `-${barcodeParts.group5[this.selectedIndex5 as number].code}`;
      else
        barcode += '-000';

      return barcode;
    }
    else {
      return '000-000-000-000-000';
    }
  }




  copy() {
    navigator.clipboard.writeText(this.getBarcode());
  }

}
